// Mirrors the Supabase Auth password policy exactly (Dashboard →
// Authentication → Sign In / Providers → Email → Password requirements) —
// that's the real gate a password has to pass regardless of what this
// checks, so a looser check here just means the form happily accepts
// something the backend then rejects, leaving the user stuck on a
// confusing error that doesn't match what this screen told them.
// Currently: minimum length 6, no required character types. If either
// setting changes in the dashboard, change this to match.
export const PASSWORD_MIN_LENGTH = 6;

export const PASSWORD_REQUIREMENTS_TEXT = `At least ${PASSWORD_MIN_LENGTH} characters.`;

export function isPasswordValid(pw) {
  return pw.length >= PASSWORD_MIN_LENGTH;
}
